import { render } from "./ViewSupportDependentDetail.vue?vue&type=template&id=6d185604"
import script from "./ViewSupportDependentDetail.vue?vue&type=script&lang=js"
export * from "./ViewSupportDependentDetail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__